import { Component, Inject, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { warningMessage } from 'src/app/constants';
import * as moment from 'moment';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';
import { ModuleStockingService } from 'src/app/services/module-stocking/module-stocking.service';
import { logErrors } from 'src/app/shared/logger';
import { ContainerTapPopupCheckboxComponent } from './container-tap-popup-checkbox.component';

@Component({
  selector: 'app-container-tap-dialog',
  templateUrl: './container-tap-dialog.component.html',
  styleUrls: ['./container-tap-dialog.component.scss']
})
export class ContainerTapDialogComponent implements OnInit{
  saveContainerTapEventEmitter = new EventEmitter();
  namcValue = localStorage.getItem('namcvalue');
  userName = localStorage.getItem('UserName');
  userRole = localStorage.getItem('UserRoles');
  user = localStorage.getItem('workdayId');
  business_entity = localStorage.getItem('namcvalue');

  rowData = [];
  @ViewChild('osPartsGrid') osPartsGrid;
  gridOptions = {} as any;
  columnDefs;
  defaultColDef;
  rowSelection;
  context: any;
  editType;
  suppressClickEdit = true;
  // errorMessage1: any;
  // errorMessageUpdate = false;
  // key_item: any;
  // data_item: any;
  // new_key_item: any;
  // cstatus: any;
  // showaddpopup: boolean = false;
  // showeditpopup: boolean = false;
  // dock: any;
  // popupname: any;
  // groupName: any;
  // countCycle:any;
  // dayWeek: any;
  // inNextDay: any;
  // dataItem: any;
  // enableError: boolean = false;
  // userForm: UntypedFormGroup;
  // shiftNumbers: any[] = [];
  // errorMessage: any;
  warningMessage: string;
  itContact: any;
  successMessage: string;
  container_renban;
  module_number;
  stocking_datetime;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<ContainerTapDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private readonly OspService: ModuleStockingService
  ) { 
    const accessEdit = this.data.accessEdit;
    this.columnDefs = [      
      {
        headerName: 'Kanban',
        field: 'kanban',
        width: 90,
        sortable: true,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Part No',
        field: 'part_no',
        width: 150,
        sortable: true,
        floatingFilter: true,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Avail',
        field: 'tap_qty',
        width: 90,
        sortable: true,
        floatingFilter: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
          return params.data.stocked ? null : params.data.tap_qty;
        }
      },
      {
        headerName: 'To Stock',
        field: 'toStock',
        width: 100,
        sortable: true,
        floatingFilter: true,
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Qty Stocked',
        field: 'tapped_qty',
        width: 120,
        sortable: true,
        floatingFilter: true,
        filter: 'agNumberColumnFilter'
      },
      {
        headerName: 'Stocked',
        field: 'stocked',
        width: 90,
        sortable: false,
        floatingFilter: false,
        cellRendererFramework: ContainerTapPopupCheckboxComponent,
        cellRendererParams: { column: 'isstocked'},
        hide: !accessEdit
      },
      {
        headerName: 'Comment',
        field: 'comment',
        width: 260,
        sortable: false,
        floatingFilter: false,
        editable: true,
        cellRenderer: function (params: any) {
          const input = document.createElement('input');
          input.type = 'text';
          input.value = params.value || '';
          input.maxLength = 250;
          input.style.border = '1px solid black';
          input.style.width = '100%';
          input.style.height = '100%';
          input.readOnly = !accessEdit;
      
          input.addEventListener('keydown', function (event: KeyboardEvent) {
            event.stopPropagation();  // This is key
          });

          input.addEventListener('change', function (event: any) {
            const newValue = event.target.value;
            params.node.setDataValue('comment', newValue);
          });
      
          return input;
        }
      },

    ];
    this.defaultColDef = {
      editable: false
    };
    // this.rowData = null;
    // this.rowData = data
    this.getGridOptions();
  }
  getGridOptions() {
    this.gridOptions = {} as any;
    this.gridOptions.headerHeight = 38;
    this.gridOptions.rowHeight = 28;
    this.gridOptions.floatingFiltersHeight = 0;
    this.gridOptions.rowBuffer = 20;
    this.gridOptions.suppressMovableColumns = true;
    this.gridOptions.enableCellTextSelection = true;
    this.gridOptions.suppressContextMenu = false;
    this.gridOptions.suppressClipboardPaste = true;
    this.gridOptions.defaultColDef = {
      sortable: true,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
      wrapText: true,
      autoHeight: true,
      suppressPaste: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      unSortIcon: true,
      icons: {
        sortUnSort: '<img src="../../../assets/images/Rectangle8.svg">',
      },
      filterParams: {
        textCustomComparator(filter, value, filterText) {
          const filterTextLoweCase = filterText.toLowerCase();

          let valueLowerCase = '';
          if (value.params) {
            valueLowerCase = value.value.toString().toLowerCase();
          } else {
            valueLowerCase = value.toString().toLowerCase();
          }
          function contains(target, lookingFor) {
            if (target === null) {
              return false;
            }
            return target.indexOf(lookingFor) >= 0;
          }
          return contains(valueLowerCase, filterTextLoweCase);
        },
        debounceMs: 1000,
        caseSensitive: true,
        suppressAndOrCondition: true,
        inRangeInclusive: true,
      },
    };
    this.gridOptions.tabToNextCell = (params: any) => {
      const nextRowIndex = params.previousCellDef.rowIndex + 1;
      const nextCol = params.previousCellDef.column.getColId();
  
      // Only tab through 'comment' field
      if (params.previousCellDef.column.getColId() === 'comment') {
        const renderedRowsCount = params.api.getDisplayedRowCount();
        if (nextRowIndex < renderedRowsCount) {
          return {
            rowIndex: nextRowIndex,
            column: 'comment',
            floating: null,
          };
        }
      }
  
      return null; // Prevent default behavior for other columns
    }
    return this.gridOptions;
  }
  
  ngOnInit(): void {
    this.rowSelection = 'multiple';
    this.onloadGrid();
  }
  
  submitted: boolean = false;
 
  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  };

  errorCallback = (error) => {
    console.error(error);
    this.hideSpinner();
    this.removeMessage();
    this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
  };
  customErrorCallback = (error, method) => {
    logErrors(error);
    this.spinner.hide();

    this.warningMessage = `Try after some time! Error in ${method}.`;
    this.rowData = [];
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
  };
  hideSpinner() {
    this.spinner.hide();
  }
  updateStockTap(){
      const griddata = this.rowData.map(m => ({
        userid : this.userName,
        dock : m.dock,
        mod_qty_received : m.tap_qty,
        tapped_qty : m.tap_qty,
        kanban : m.kanban,
        container_renban : m.container_renban,
        module_number : m.module_number,
        old_tapped_qty : m.tap_qty,
        tap_history : "",
        isStocked : m.stocked,
        stocked_date : (m.stocked) ? moment().tz('America/New_York').format('MM/DD/YYYY') : null,
        stocked_datetime : m.stocking_datetime,
        comment : m.comment ? m.comment.trim() : m.comment
      }));

      const payload = {
        business_entity : this.business_entity,
        workid : this.user,
        user_role : this.userRole,
        userid : this.userName,
        data : griddata
      }
      const anyStocked = !griddata.some(item => item.isStocked === false);
      const obj = {payload, anyStocked};
      this.saveContainerTapEventEmitter.emit(obj);
      this.dialogeRef.close();
  }

  onloadGrid() {
    if (this.osPartsGrid) {
      this.osPartsGrid.gridOptions.api.refreshHeader();
    }
    this.removeMessage();
    let selectedPartNo;

    const data = {
      business_entity: this.namcValue,
      dock: this.data.dock,
      container_renban : this.data.container_renban,
      module_number : this.data.module_number,
      workid: this.user,
      user_role: this.userRole,
      stockingDtFrom : this.data.stockingDtFrom,
      stockingDtTo : this.data.stockingDtTo
    };

    this.spinner.show();
    this.OspService.scheduleTap(data).subscribe({
      error: this.errorCallback,
      next: (res) => {
        if (res?.error) {
          this.customErrorCallback(res?.error, "get Schedule Tap Details");
        }{
          console.log(res, 'res')
          if (res.body.length > 0) {
            this.rowData = res.body;
            this.container_renban =  this.data.container_renban;
            this.module_number =  this.data.module_number;
            this.stocking_datetime =  this.data.planned_stocking_datetime;
            this.osPartsGrid.gridOptions.api.setRowData(this.rowData);
          } else {
            this.rowData = [];
          }
          this.spinner.hide();
        }
      },
    });
    return true;
  }
}
